/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExpandMore, Search } from '@mui/icons-material';
import { Box, Accordion, AccordionSummary, Typography, AccordionDetails, Divider, IconButton } from '@mui/material';
import { IDetalhesAnomalia } from '../../../services/api/anomaly/AnomalyService'; 
import { useNavigate, useParams } from 'react-router-dom';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';
import { estruturaAnomaliasMap } from './FormAnomalia';

interface AccordionHistoryAnomalyProps { 
    data: IDetalhesAnomalia[]; 
}

export default function AccordionHistoryAnomaly({ data }: AccordionHistoryAnomalyProps) {
    const navigate = useNavigate();
    const url = useParams();

    const getItemLabel = (itemValue: string): string => {
        for (const key in estruturaAnomaliasMap) {
            const opcoes = estruturaAnomaliasMap[key];
            const found = opcoes.find(opt => opt.value === itemValue);
            if (found) return found.label;
        }
        return itemValue;
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, paddingY: 2, width: '100%' }}>
            {data?.map((detailItem, index) => { 
                const anomalyOriginalUuid = url.anomaly;

                return (
                    <Accordion
                        key={detailItem.uuid || `detail-${index}`}
                        square={true}
                        sx={{ borderRadius: '30px', '&:before': { display: 'none', } }}
                        disableGutters
                    >
                        <AccordionSummary
                            sx={{ borderRadius: '25px' }}
                            expandIcon={<ExpandMore />}
                        >
                            <Typography variant='subtitle1'>
                                <strong>Data da Inspeção: </strong>{formatDateWhitoutHour(detailItem.data_inspecao)}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant='body1'><strong>Item de Inspeção:</strong> {getItemLabel(detailItem.item)}</Typography>
                            <Typography variant='body1'><strong>Situação:</strong> {detailItem.situacao}</Typography>
                            <Typography variant='body1'><strong>Magnitude:</strong> {detailItem.magnitude}</Typography>
                            <Typography variant='body1'><strong>NPA:</strong> {detailItem.npa}</Typography>
                            <Typography variant='body1'><strong>Observações da Inspeção:</strong> {detailItem.observacoes_gerais}</Typography>
                            <Typography variant='body1'><strong>Data da Inspeção:</strong> {formatDateWhitoutHour(detailItem.data_inspecao)}</Typography>
                            {detailItem.reservatorio_seco && <Typography variant='body1'><strong>Reservatório Seco:</strong> Sim</Typography>}
                            {detailItem.vertimento_extravasor && <Typography variant='body1'><strong>Vertimento Extravasor:</strong> Sim</Typography>}
                            {detailItem.fluxo && <Typography variant='body1'><strong>Fluxo:</strong> Sim</Typography>} 

                            <Divider sx={{ my: 1 }} />

                            {/* <Box display={'flex'} justifyContent={'end'} width={'100%'}>
                                <IconButton onClick={() => navigate(`/information_dam/${url.id}/anomaly/${anomalyOriginalUuid}`)}>
                                    <Search />
                                </IconButton>
                            </Box> */}
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Box>
    );
}